<template>
    <v-app id="inspire">
    <v-main>
        <v-container
            class="fill-height"
            fluid
        >
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
            <v-card class="elevation-12">
                <v-toolbar
                    color="primary"
                    dark
                    flat
                >
                <v-toolbar-title>Login form</v-toolbar-title>

                </v-toolbar>
                <v-card-text>
                <v-form ref="login">
                    <v-text-field
                        label="E-pasts"
                        name="email"
                        prepend-icon="mdi-account"
                        type="text"
                        v-model="emailModel"
                        required
                        :rules="emailRule"
                        @change="fieldChanging"
                        @keypress.enter="login"
                    ></v-text-field>

                    <v-text-field
                        id="password"
                        label="Parole"
                        name="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        v-model="passwordModel"
                        :rules="passwordRule"
                        @change="fieldChanging"
                        @keypress.enter="login"
                    ></v-text-field>        
                </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
                </v-card-actions>
                <v-progress-linear indeterminate v-show="loading"></v-progress-linear>
            </v-card>
            </v-col>
        </v-row>
        </v-container>
    </v-main>
    </v-app>
</template>

<script>
import { mapActions } from 'vuex';
  export default {
    data() {
        return {
            email: null,
            password: null,
            loading: false,
            incorrect: false,
            emailRule: [
                v => !!v || "Nepieciešams e-pasts",
                v => !this.incorrect,
            ],

            passwordRule: [
                v => !!v || "Nepieciešama parole",
                v => !this.incorrect || "Nepareizs e=pasts vai parole"
            ]
        }
    },

    computed: {
        emailModel: {
            set: function(value) {
                this.fieldChanging();
                this.email = value;
            },

            get: function() {
                return this.email;
            }
        },

        passwordModel: {
            set: function(value) {
                this.fieldChanging();
                this.password = value;
            },

            get: function() {
                return this.password;
            }
        },

        // loggedIn() {
        //     return this.$store.state.auth.status.loggedIn;
        // }
    },

    methods: {
        ...mapActions({
            signin: 'auth/login',
        }),
        
        login: function() {
            this.signin({email: this.email, password: this.password});
        },

        fieldChanging: function() {
            if (this.incorrect) {
                this.incorrect = false;
                this.$refs.login.validate();
            }
        }
    },

}
</script>